<template>
    <div class="interest area">
        <div class="interestTitle">
            <span @click="backPage" :class="{colorBlack:!interestShow}">{{$t('interest.title')}}</span>
            <div class="titleRight" v-show="!interestShow">
                <i></i>
                <span>{{$t('interest.text1')}}</span>
            </div>
        </div>
        <div v-show="interestShow">

            <div style="margin-top:25px;border-bottom:1px solid #F7F7F7;">
                <span class="item" :class="{itemColor:item.id === headerId}" v-for="(item,index) in interestType" :key="index" @click="choose(item.id)">{{item.name}}</span>
            </div>


            <div class="maxHeight" v-show="!nothingShow">
                <ul class="content">
                    <li v-for="(item,index) in dataList" :key="index" :class="`cardBgc${item.status}`" @click.stop="toDetail(item)">
                        <div class="name">
                            <div class="left">
                                <i :class="`leftIcon${item.status}`"></i>
                                <span class="UserName" :class="`contentColor${item.status}`">{{item.name}}</span>
                            </div>
                            <div class="right">
                                <span :class="`rightColor${item.status}`">{{item.statusName}}</span>
                                <i class="rightIcon" :class="`rightIcon${item.status}`"></i>
                            </div>
                        </div>

                        <p class="interestRate" :class="`contentColor${item.status}`">{{$t('interest.text2')}}{{item.minRate}}%~{{item.maxRate}}%</p>
                        <p class="interval" :class="`intervalColor${item.status}`">{{$t('interest.text3')}}{{item.startTime}}~{{item.endTime}}</p>

                        <div class="interestButton">
                            <span class="cursorPoint" :class="`receive${item.status}`" @click.stop="toReceive(item)">{{item.buttonText}}</span>
                        </div>

                    </li>
                </ul>
            </div>


            <div class="null interestNull" v-show="nothingShow">
                <img loading="lazy" class="nullImg" v-lazy="require('../../../assets/images/xf/null.png')" alt="">
                <p class="nullText">{{$t('record.text4')}}</p>
            </div>

            <div class="pagination">
                <span @click.stop="toDetail()">{{$t('interest.text4')}}</span>
                <el-pagination small layout="prev, pager, next" :pageSize="10" @current-change="query" :total="total" :current-page.sync="currentPage"></el-pagination>
            </div>
        </div>

        <div v-show="!interestShow">
            <div class="deposit">
                <div style="width: 90%;height: 560px;overflow: scroll;">
                    <div class="header">
                        <h2>{{detail.name}}</h2>
                        <p class="time">{{$common.conversionTime(detail.startTime)}} - {{$common.conversionTime(detail.endTime)}}</p>
                    </div>
                    
                    <p class="totalAmount">
                        {{$t('interest.text5')}}
                        {{$common.setNumFixed(detail.totalDeposit, 2)}}
                        {{$t('interest.text6')}}
                        {{$common.setNumFixed(detail.totalDepositLimit - detail.totalDeposit, 2)}}
                        {{$t('interest.text7')}}</p>
                    <p class="number">
                        {{$t('interest.text8')}}
                        {{detail.totalDepositRoll}}
                        {{$t('interest.text9')}}
                        {{detail.depositRollLimit - detail.totalDepositRoll}}
                        {{$t('interest.text10')}}</p>
                    <div class="amount">
                        <span>{{$t('interest.text11')}}</span>
                        <input type="number" v-model="deposit" :placeholder="`${$t('interest.text12')}${$common.setNumFixed(minAmount, 2)}${$t('interest.text13')}`" @blur="calculate">
                    </div>
                    <p class="interestRate">
                        {{$t('interest.text14')}}
                        {{interestrate}}%，
                        {{$t('interest.text15')}}
                        {{$common.setNumFixed(interest, 2)}}
                        {{$t('interest.text16')}}</p>
                    <span class="interestRateTitle">{{$t('interest.text17')}}</span>
                    <el-collapse class="borderRadius">
                        <el-collapse-item v-for="(item,index) in detail.levelData" :key="index">
                            <template slot="title">
                                <div class="left">
                                    <i></i>
                                    <span>
                                        {{$t('interest.text18')}}
                                        {{$common.setNumFixed(item.amount, 2)}}
                                        {{$t('interest.text19')}}</span>
                                </div>
                                <div class="highest">{{$t('interest.text20')}}{{item.apr}}%</div>
                            </template>
                            <div class="timeAndInterest" v-for="(i,k) in item.detail" :key="k">
                                <div class="timeAndInterestItem">
                                    <span>{{i.time}}{{$t('interest.text21')}}</span>
                                    <span>{{$t('interest.text22')}}{{i.apr}}%</span>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="depositButton">
                    <span @click="depositImmediately">{{$t('interest.text23')}}</span>
                </div>
            </div>
        </div>
        <el-dialog class="receive" :visible.sync="successfully" :before-close="successfullyClose" :show-close="false" style="border-radius: 0.1rem;">
            <span class="title">{{$t('interest.text24')}}</span>
            <img loading="lazy" class="dialogClose" v-lazy="require('../../../assets/images/xf/close.png')" @click="successfullyClose" />
            <div>
                <p class="p2" style="margin-top:20px;padding:0 80px;box-sizing:border-box;text-align:center;">{{$t('interest.text25')}}</p>
            </div>
            <span class="footer-button">
                <el-button type="primary" @click="cancel()" class="button-right" style="margin:0;height: 40px;">{{$t('interest.text26')}}</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
export default {
    data() {
        return {
            depositShow: false,
            interestShow: true,
            successfully: false,
            nothingShow: false,
            total: 1,
            currentPage: 1,
            deposit: '',// 存入金额
            minAmount: '0.00',// 购买利息说明中的最低金额
            interestrate: '0',// 利率
            interest: '0.00',// 利息
            largestAmount: '',// 可再存入金额
            remainingNumber: '',
            interestId: '',// 利息宝ID
            headerId: '',
            id: '',
            interestType: [
                {
                    name: this.$t('interest.text27'),
                    'id': ''
                },
                {
                    name: this.$t('interest.text28'),
                    'id': '0'
                },
                {
                    name: this.$t('interest.text29'),
                    'id': '1'
                },
                {
                    name: this.$t('interest.text30'),
                    'id': '2'
                }
            ],
            dataList: [],
            detail: {}
        };
    },
    created() {
        this.query(1);
    },
    methods: {
        init(){
            this.interestShow = true;
        },
        // 返回利息宝
        backPage() {
            this.interestShow = true;
        },
        // 选中
        choose(id) {
            this.headerId = id;
            this.dataList = [];
            switch (id) {
                case '0':// 進行中
                    this.id = 4;
                    break;
                case '1':// 未開放
                    this.id = 3;
                    break;
                case '2':// 已結束
                    this.id = 2;
                    break;
                default:// 全部
                    this.id = '';
            }
            this.query(1);
        },
        // 去存款
        toDetail(item) {
            if(item){
                this.interestShow = false;
                this.interestId = item.id;
                this.interestDetail(item);
            }else{
                this.$router.push({
                    path:'/my/tradingRecord',
                    name:'tradingRecord',
                    params:{
                        id:6,
                        item:item
                    }
                })
            }
        },
        toReceive(item) {
            // status 12是結束，34對應進行中未開放
            switch (item.status) {
                case 1:
                case 2:
                    this.$router.push({
                        path:'/my/tradingRecord',
                        name:'tradingRecord',
                        params:{
                            id:6,
                            item:item
                        }
                    })
                    break;
                case 3:
                case 4:
                    this.interestShow = false;
                    this.interestId = item.id;
                    this.interestDetail(item);
                    break;
            }
        },
        // 获取详情
        interestDetail(item) {
            let that = this;
            that.$http.get(that.$api.interestDetail,item.id).then((res) => {
                if (res.data && res.data.levelData) {
                    res.data.levelData = res.data.levelData.sort((a, b) => a.amount - b.amount);
                    this.minAmount = Math.min.apply(Math, res.data.levelData.map(function(min) {
                        return min.amount;
                    }));
                    this.detail = res.data;
                }
            });
        },
        successfullyClose() {
            this.successfully = false;
        },
        // 存款成功提示窗口关闭
        cancel() {
            this.successfully = false;
        },
        // 计算利息
        calculate() {
            let that = this;
            that.deposit = that.deposit - 0;// 存入金额
            that.largestAmount = that.$common.setNumFixed(that.detail.totalDepositLimit - that.detail.totalDeposit, 2) - 0;// 可再存入
            that.remainingNumber = that.detail.depositRollLimit - that.detail.totalDepositRoll;
            let data = {
                'amount': that.deposit,
                'interestId': that.interestId
            };

            if (that.deposit >= that.minAmount && that.deposit <= that.largestAmount && that.deposit <= that.detail.maxDepositLimit && that.remainingNumber > 0) {
                that.$http.post(that.$api.profitForecast,data).then((res) => {
                    if (res) {
                        that.interest = res.data.interest;
                        that.interestrate = res.data.apr;
                    } else {
                        that.interestrate = '0';
                        that.interest = '0.00';
                    }
                });
            } else {
                if (that.deposit < that.minAmount) {
                    that.$message({
                        message: that.$t('interest.text31'),
                        type: 'error'
                    });
                } else if (that.deposit > that.largestAmount) {
                    that.$message({
                        message: that.$t('interest.text32'),
                        type: 'error'
                    });
                } else if (that.deposit > that.detail.maxDepositLimit) {
                    that.$message({
                        message: that.$t('interest.text33'),
                        type: 'error'
                    });
                } else if (that.remainingNumber == 0) {
                    that.$message({
                        message: that.$t('interest.text34'),
                        type: 'error'
                    });
                }
                that.interestrate = '0';
                that.interest = '0.00';
            }
        },
        // 立即存入
        depositImmediately() {
            let that = this;
            if (that.deposit) {
                that.deposit = that.deposit - 0;
                if (that.deposit >= that.minAmount && that.deposit <= that.largestAmount && that.deposit <= that.detail.maxDepositLimit && that.remainingNumber > 0) {
                    let data = {
                        amount: that.deposit,
                        interestId: that.interestId
                    };
                    that.$http.post(that.$api.join,data).then((res) => {
                        if (res.code === 0) {
                            that.deposit = '';
                            that.interestrate = '0';
                            that.interest = '0.00';
                            var item = {
                                id:that.interestId
                            };
                            that.interestDetail(item);
                            that.successfully = true;
                        } else {
                            let msg = that.$t(`errorCode.${res.code}`) + `(${res.code})` || that.$t('errorCode.webDefault');
                            that.$http.errMsg(msg);
                        }
                    });
                } else {
                    if (that.deposit < that.minAmount) {
                        that.$message({
                            message: that.$t('interest.text31'),
                            type: 'error'
                        });
                    } else if (that.deposit > that.largestAmount) {
                        that.$message({
                            message: that.$t('interest.text32'),
                            type: 'error'
                        });
                    } else if (that.deposit > that.detail.maxDepositLimit) {
                        that.$message({
                            message: that.$t('interest.text33'),
                            type: 'error'
                        });
                    } else if (that.remainingNumber == 0) {
                        that.$message({
                            message: that.$t('interest.text34'),
                            type: 'error'
                        });
                    }
                }
            } else {
                that.$message({
                    message: that.$t('interest.text35'),
                    type: 'error'
                });
            }
        },
        // 请求数据
        query(val = 1) {
            let that = this;
            let data = {
                currentPage: val,
                pageSize: 10,
                type: this.id
            };
            that.$http.post(that.$api.interest, data).then((res) => {
                if (res && res.data && res.data.totalRecords > 0) {
                    that.nothingShow = false;
                    res.data.content.map((item) => {
                        item.startTime = that.$common.conversionTime(item.startTime);
                        item.endTime = that.$common.conversionTime(item.endTime);
                        switch (item.status) {
                            case 3:// 未开放
                                item.statusName = that.$t('interest.text36');
                                item.buttonText = that.$t('interest.text37');
                                break;
                            case 4:// 进行中
                                item.statusName = that.$t('interest.text38');
                                item.buttonText = that.$t('interest.text39');
                                break;
                            case 2:
                                item.statusName = that.$t('interest.text40');
                                item.buttonText = that.$t('interest.text41');
                                break;
                            case 1:
                                item.statusName = that.$t('interest.text42');
                                item.buttonText = that.$t('interest.text41');
                                break;
                        }
                    });
                    that.dataList = res.data.content;
                } else {
                    that.nothingShow = true;
                }
            });
        }
    }
};

</script>
<style lang="less">
.interest{
    .header{
        height: 88px;
        // border-top: 1px solid #F7F7F7;
        border-bottom: 1px solid #F7F7F7;
    }
    .interestNull{
        width: 100%;
        height: 520px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .nullImg{
            width: 215px;
            height: 165px;
        }
    }
    .el-dialog{
        border-radius: 10px;
        width: 388px;
        min-width: 388px !important;
    }
    .interestTitle{
        color: #333333;
        font-size: 14px;
        display: flex;
        margin-top:25px;
        .titleRight{
            display: flex;
            align-items: center;
            i{
                width: 7px;
                height: 13px;
                background: url('../../../assets/images/xf/connectionIcon.png') no-repeat;
                background-size: 100% 100%;
                margin: 0 10px;
            }
            span{
                color: #E91919;
            }
        }
        .colorBlack{
            cursor: pointer;
            font-weight: bold;
            color: #3E444D;
        }
    }
    .item{
        cursor: pointer;
        display: inline-block;
        width: 180px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        font-size: 16px;
        color: #333333;
        &:hover{
            color: #E91919;
        }

    }
    .itemColor{
        color: #E91919;
        border-bottom: 2px solid #E91919;
    }
    .maxHeight {
        display: inline-block;
        height: 530px;
        width: 100%;
        overflow: scroll;
        margin-top: 10px;
        width: 70%;
    }

  //   内容卡片区域
    .content {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        li{
            width: 48%;
            height: 180px;
            border-radius: 10px;
            margin-top: 20px;
            color: #fff;
            font-size: 12px;
            padding: 12px;
            position: relative;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            .name{
                display: flex;
                justify-content: space-between;
                .UserName{
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 120px;
                    font-size: 12px;
                    white-space: nowrap;
                    text-align: left;
                }
                .left,.right{
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    i{
                        width: 10px;
                        height: 10px;
                        display: inline-block;
                    }
                    .leftIcon4{
                        background: url('../../../assets/images/xf/icon1.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .leftIcon3{
                        background: url('../../../assets/images/xf/icon2.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .leftIcon2{
                        background: url('../../../assets/images/xf/icon3.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .leftIcon1{
                        background: url('../../../assets/images/xf/icon4.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .rightIcon{
                        width: 20px;
                        height: 20px;
                        background: url('../../../assets/images/xf/righticon1.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .rightIcon4{
                        background: url('../../../assets/images/xf/righticon1.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .rightIcon3{
                        background: url('../../../assets/images/xf/righticon2.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .rightIcon2{
                        background: url('../../../assets/images/xf/righticon3.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    .rightIcon1{
                        background: url('../../../assets/images/xf/righticon4.png') no-repeat;
                        background-size: 100% 100%;
                    }
                    span{
                        margin-left: 5px;
                    }
                }
                .rightColor4{
                    color:#FFFFFF;
                }
                .rightColor3{
                    color:#11AEFF;
                }
                .rightColor2{
                    color:#FF631E;
                }
                .rightColor1{
                    color:#A7A7A7;
                }
            }
            P{
                text-align: left;
            }

            .interestRate{
                font-size: 16px;
                font-weight: bold;
                margin-top: 30px;
            }
            .interval{
                font-size: 12px;
                color: #FFFFFF;
                opacity: 0.7;
                margin-top:10px;
            }
            .contentColor4{
                color:#FFFFFF;
            }
            .contentColor3,.contentColor2,.contentColor1{
                color:#1D1717;
            }
            .intervalColor4{
                color:#FFFFFF;
            }
            .intervalColor3,.intervalColor2,.intervalColor1{
                color:#A7A7A7;
            }
        }
        .cardBgc4{
            background: url('../../../assets/images/xf/interest1.png') no-repeat;
            background-size: 100% 100%;
        }
        .cardBgc3{
            background: url('../../../assets/images/xf/interest2.png') no-repeat;
            background-size: 100% 100%;
        }
        .cardBgc2{
            background: url('../../../assets/images/xf/interest3.png') no-repeat;
            background-size: 100% 100%;
        }
        .cardBgc1{
            background: url('../../../assets/images/xf/interest4.png') no-repeat;
            background-size: 100% 100%;
        }
    }
    .interestButton{
        width: 100%;
        text-align: right;
        margin-top: 16px;
        span{
            border-radius: 20px;
            padding: 5px 18px;
        }
        .receive4{
            background-color:#FFF9A4;
            color:#FF631E;
        }
        .receive3{
            background-color:#11AEFF;
            color:#FFFFFF;
        }
        .receive2{
            background-color:#FF631E;
            color:#FFFFFF;
        }
        .receive1{
            background-color:#A7A7A7;
            color:#FFFFFF;
        }
    }
    .pagination{
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        span{
            cursor: pointer;
            color: #999999;
            font-size: 14px;
        }
        .el-pager li,.el-pagination--small .el-pager li:last-child{
            font-size: 14px;
        }
    }

    .deposit{
        width: 90%;
        box-sizing: border-box;
        margin-top: 45px;
        font-size: 14px;
        .time{
            color: #424242;
            opacity: 0.7;
            font-size: 14px;
        }
        .totalAmount{
            color: #424242;
            margin-top: 18px;
        }
        .number{
            margin-top: 18px;
        }
        .amount{
            display: flex;
            margin-top: 30px;
            flex-wrap: nowrap;
            align-items: center;
            span{
                width: 80px;
            }
            input{
                height: 50px;
                border-radius: 4px;
                border: none;
                padding-left: 20px;
                border: 1px solid #CCCCCC;
                box-sizing: border-box;
                width: 100%;
            }
        }
        .interestRate{
            color: #F9A425;
            text-align: right;
            width: 100%;
            margin-top: 15px;
        }
        .interestRateTitle{
            margin-top: 55px;
            width: 100%;
            display: inline-block;
        }
        .borderRadius{
            margin-top: 15px;
        }
        .el-collapse,.el-collapse-item__wrap{
            border: none;
        }
        .el-collapse-item__wrap{
            border-top: 1px solid #e1e1e1;
        }
        .el-collapse-item{
            border: 1px solid #e1e1e1;
            border-radius: 10px;
        }
        .el-collapse-item__header{
            display: flex;
            justify-content: space-between;
            border-radius: 10px;
        }
        .el-collapse-item {
            background-color: #ffffff;
            margin-top: 10px;
        }
        .el-icon-arrow-right{
            display: none;
        }
        .el-collapse-item__content{
            padding-bottom: 15px;
        }
        .el-collapse-item__wrap{
            border-radius: 0 0 10px 10px;
        }
        .left{
            margin-left: 20px;
            i{
                display: inline-block;
                width: 12px;
                height: 12px;
                background: url('../../../assets/images/xf/icon.png') no-repeat;
                background-size: 100% 100%;
            }
            span{
                color: #313131;
                font-size: 16px;
                margin-left: 10px;
            }
        }
        .highest{
            margin-right: 16px;
            color: #F9A425;
        }
        .timeAndInterest{
            display: flex;
            flex-direction: column;
        }
        .timeAndInterestItem{
            display: flex;
            justify-content: space-between;
            margin-top: 15px;
            padding: 0 20px 0 50px;
            box-sizing: border-box;
        }
        .depositButton{
            width: 90%;
            text-align: right;
            margin-top: 30px;
            span{
                display: inline-block;
                width: 168px;
                height: 46px;
                background: #E91919;
                cursor: pointer;
                color: #FFFFFF;
                border-color: #E91919;
                border-radius: 22px;
                text-align: center;
                line-height: 46px;
                cursor: pointer;
                &:hover{
                    opacity: 0.9;
                }
            }
        }

    }

    input::-webkit-outer-spin-button,input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    }
    input[type="number"]{
        -moz-appearance: textfield;
    }
}

</style>
<style lang="less">
    @import url('../../../assets/css/common.css');
.receive{
    .el-dialog {
        min-width: 426px;
        padding-bottom: 10px;
        box-sizing: border-box;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        margin-top: 0 !important;
        .el-dialog__body {
            padding: 0;
            height: 100%;
        }
        .el-button {
            padding: 0;
        }
    }
    p{
        margin-top: 10px;
        text-align: center;
    }
    .p1{
        color: #333333;
        font-size: 32px;
        margin-top: 20px;
    }
    .p2{
        color: #2D2B4D;
        font-size: 14px;
        font-weight: 500;
    }
    .p3{
        color: #1D1717;
        font-size: 18px;
        font-weight: 500;
    }
    .p4{
        color: #A7A7A7;
        font-size: 14px;
        font-weight: 500;
    }
    .title {
        height: 0.55rem;
        box-sizing: border-box;
        border-radius: 0.1rem 0.1rem 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.28rem;
        padding-top: 0.32rem;
        color: #333333;
        font-weight: bold;
    }
    .el-dialog__close {
        font-size: 0.3rem;
    }
    .footer-button {
        display: flex;
        justify-content: space-around;
        margin: 20px 0;
        .el-button {
            width: 131px;
            height: 46px;
            text-align: center;
            font-size: 14px;
            font-weight: 500;
            border: none;
            border-radius: 22px;
        }
        .button-left {
            margin-left: 40px;
            border: 1px solid #E91919;
            color: #E91919;
            &:hover{
                background-color: #ffffff;
            }
        }
        .button-right {
            margin-right: 0.4rem;
            color: #ffffff;
            background: #E91919;
        }
        
    }
    .el-dialog__header {
        padding: 0;
    }
    .dialogClose {
        width: 17px;
        height: 17px;
        position: absolute;
        top: 0.14rem;
        right: 0.14rem;
        transition: 1s;
    }
    .el-button--primary{
        border: none;
    }
    
}

</style>